// import axios from '../plugins/axios'
const state = {
  is_from_project : false,
  co_project_id: '',
  co_group_id: '',
  co_item_id: '',
  redirect_to:'',
  co_co_id:'',
  is_from_dashboard:false,
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {

}
const mutations = {
  setTransactionData(state,data){
    localStorage.setItem(data.key, data.value)
    state[data.key] = data.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}